import { Injectable } from '@angular/core';
import { utc, Moment } from 'moment-timezone';
import { environment } from '../../environments/environment';
import {HttpResponse} from '@angular/common/http';
import {HttpService} from './http.service';


@Injectable()
export class ServerTimeService {

    private _initClientTime: Moment;
    private _initServerTime: Moment;
    private _difference: number;

  constructor(
      private httpService: HttpService
  ) {
      this.httpService.get(environment.apiV1BaseUrl + '/facilities/server-time', { observe: 'response' })
          .subscribe(
              (serverTime: HttpResponse<string>) => {

                  this._initServerTime = utc(serverTime.body);
                  this._initClientTime = utc();
                  this._difference = this._initServerTime.diff(this._initClientTime, 'seconds');
              },
              error => console.error('Stream Error: %s', error)
          );

  }

  now(): Moment {
      // TODO: IMPLEMENT THIS
      return utc().add({ seconds: this._difference });
  }

}
